import { CustomButtonActionHandler } from './custom-button-action-handler';
import { SendDataToApiActionProcessor } from '@shared/components/custom-action-button/action-processors/send-data-to-api-action-processor';
import { ShowPopupActionProcessor } from '@shared/components/custom-action-button/action-processors/show-popup-action-processor';
import { Injectable } from '@angular/core';
import { NavigateToUrlActionProcessor } from '@shared/components/custom-action-button/action-processors/navigate-to-url-action-processor';
import { ExecuteCustomLogicActionProcessor } from '@shared/components/custom-action-button/action-processors/execute-custom-logic-action-processor';
import { CloseAllPopupsActionProcessor } from '@shared/components/custom-action-button/action-processors/close-all-popups-action-processor';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { RedrawComponentsActionProcessor } from '@shared/components/custom-action-button/action-processors/redraw-components-action-processor';
import { SetFieldValueActionProcessor } from '@shared/components/custom-action-button/action-processors/set-field-value-action-processor';
import { ToggleComponentsVisibilityActionProcessor } from '@shared/components/custom-action-button/action-processors/toggle-components-visibility-action-processor';
import { TriggerEventActionProcessor } from '@shared/components/custom-action-button/action-processors/trigger-event-action-processor';
import {
  GoBackActionProcessor
} from "@shared/components/custom-action-button/action-processors/go-back-action-processor";
import {
  RefreshPageActionProcessor
} from "@shared/components/custom-action-button/action-processors/refresh-page-action-processor";

@Injectable({ providedIn: 'root' })
export class CustomButtonActionHandlerRegistry {
  handlers: CustomButtonActionHandler[] = [];

  constructor(
    private readonly showPopupActionProcessor: ShowPopupActionProcessor,
    private readonly sendDataToApiActionProcessor: SendDataToApiActionProcessor,
    private readonly navigationActionProcessor: NavigateToUrlActionProcessor,
    private readonly customLogicActionProcessor: ExecuteCustomLogicActionProcessor,
    private readonly closePopupsActionProcessor: CloseAllPopupsActionProcessor,
    private readonly redrawComponentsActionProcessor: RedrawComponentsActionProcessor,
    private readonly fieldValuesActionProcessor: SetFieldValueActionProcessor,
    private readonly toggleComponentsVisibilityActionProcessor: ToggleComponentsVisibilityActionProcessor,
    private readonly triggerEventActionProcessor: TriggerEventActionProcessor,
    private readonly goBackActionProcessor: GoBackActionProcessor,
    private readonly refreshPageActionProcessor: RefreshPageActionProcessor
  ) {
    this.handlers.push(
      showPopupActionProcessor,
      sendDataToApiActionProcessor,
      navigationActionProcessor,
      customLogicActionProcessor,
      customLogicActionProcessor,
      closePopupsActionProcessor,
      redrawComponentsActionProcessor,
      fieldValuesActionProcessor,
      toggleComponentsVisibilityActionProcessor,
      triggerEventActionProcessor,
      goBackActionProcessor,
      refreshPageActionProcessor
    );
  }

  public setDialogRef(ref: DynamicDialogRef) {
    this.closePopupsActionProcessor.setDialogRef(ref);
  }
  provider(actionType: CustomButtonActionType): CustomButtonActionHandler {
    return this.handlers.find(h => h.isApplicable(actionType))!;
  }
}

export enum CustomButtonActionType {
  goBack = 'goBack',
  closeAllPopups = 'closeAllPopups',
  downloadFile = 'downloadFile',
  executeCustomLogic = 'executeCustomLogic',
  getDataFromApi = 'getDataFromApi',
  navigateToUrl = 'navigateToUrl',
  redrawComponents = 'redrawComponents',
  refreshCurrentPage = 'refreshCurrentPage',
  resetSmartTableResults = 'resetSmartTableResults',
  sendDataToApi = 'sendDataToApi',
  toggleComponentsVisibility = 'toggleComponentsVisibility',
  triggerEvent = 'triggerEvent',
  setFieldValues = 'setFieldValues',
  showPopup = 'showPopup',
  smartTableAdvanceFilterAction = 'smartTableAdvanceFilterAction'
}

export enum CustomActionType {
  navigate = 'navigate',
  advanceFilterAction = 'applyFilter',
  resetSmartTableResults = 'resetSmartTableResults',
  showPopup = 'showPopup',

  getDataFromApi = 'getDataFromApi',
  executeScriptAndShowPopup = 'executeScriptAndShowPopup',

  downloadFile = 'downloadFile',

  others = 'others',

  postToUrl = 'postToUrl'
}

export enum AfterPostToUrlAction {
  showPopup = 'showPopup',
  navigate = 'navigate',
  showPopupAndNavigate = 'showPopupAndNavigate',
  noAction = 'noAction',
  downloadFile = 'downloadFile',
  processApiResponse = 'processApiResponse'
}
